import { useParams } from 'react-router-dom';
import ScreenTable from 'modules/dashboard/screens/Dashboard/components/ScreenTable';
// import useGetListScreens from 'modules/dashboard/services/hooks/useGetListScreens';
// import { useEffect } from 'react';

const ListScreen = () => {
  const { id } = useParams<{ id: string }>();
  // const { screensList, screensParams, mutate } = useGetListScreens(true);

  // useEffect(() => {
  //   if (id) {
  //     mutate({ page: 1, size: 10, storeId: id });
  //   }
  // }, [id]);

  return (
    <ScreenTable id={id} />
  );
};

export default ListScreen;
